import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M18.483 2.42004H5.52498C3.58598 2.42004 2.00698 3.99904 2.00498 5.94004L2.00098 9.43704C2.00098 9.59604 2.06398 9.74904 2.17698 9.86204C2.28898 9.97504 2.44198 10.038 2.60098 10.038H7.91798C8.24998 10.038 8.51798 9.76904 8.51798 9.43804V6.82904H15.459V9.43804C15.459 9.59704 15.521 9.75004 15.635 9.86204C15.747 9.97504 15.9 10.038 16.059 10.038H16.06L21.403 10.029C21.734 10.029 22.002 9.76004 22.002 9.42904V5.94104C22.001 4.00004 20.424 2.42004 18.484 2.42004H18.483ZM20.801 8.82904L16.658 8.83604V6.22804C16.658 6.06904 16.596 5.91604 16.483 5.80404C16.37 5.69204 16.217 5.62804 16.058 5.62804H7.91698C7.58498 5.62804 7.31698 5.89704 7.31698 6.22804V8.83704H3.20098L3.20498 5.94004C3.20598 4.66004 4.24698 3.61904 5.52398 3.61904H18.482C19.759 3.61904 20.799 4.66004 20.799 5.94004V8.82904H20.801Z"
      fill="currentColor"
    />
    <path
      d="M18.696 11.519C18.365 11.519 18.096 11.788 18.096 12.119V18.555C18.096 19.562 17.277 20.381 16.27 20.381H7.69304C6.68504 20.381 5.86504 19.562 5.86504 18.555V12.136C5.86504 11.804 5.59604 11.536 5.26504 11.536C4.93404 11.536 4.66504 11.805 4.66504 12.136V18.555C4.66504 20.223 6.02304 21.58 7.69304 21.58H16.27C17.938 21.58 19.295 20.223 19.295 18.555V12.119C19.296 11.788 19.027 11.519 18.696 11.519V11.519Z"
      fill="currentColor"
    />
    <path
      d="M10.1471 17.124C10.6561 17.124 11.0701 16.71 11.0701 16.201C11.0701 15.691 10.6561 15.277 10.1471 15.277C9.63812 15.277 9.22412 15.691 9.22412 16.201C9.22412 16.719 9.62912 17.124 10.1471 17.124Z"
      fill="currentColor"
    />
    <path
      d="M14.775 16.201C14.775 16.711 14.362 17.124 13.852 17.124C13.342 17.124 12.929 16.711 12.929 16.201C12.929 15.691 13.342 15.278 13.852 15.278C14.362 15.278 14.775 15.691 14.775 16.201Z"
      fill="currentColor"
    />
    <path
      d="M11.0701 12.58C11.0701 13.09 10.6571 13.503 10.1471 13.503C9.63712 13.503 9.22412 13.09 9.22412 12.58C9.22412 12.07 9.63712 11.657 10.1471 11.657C10.6571 11.657 11.0701 12.07 11.0701 12.58Z"
      fill="currentColor"
    />
    <path
      d="M14.775 12.58C14.775 13.09 14.362 13.503 13.852 13.503C13.342 13.503 12.929 13.09 12.929 12.58C12.929 12.07 13.342 11.657 13.852 11.657C14.362 11.657 14.775 12.07 14.775 12.58Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'FixedLine');

export default Icon;
